import { TabularCopySink } from './tabular.copysink';
import { IModel, IViolation, IAttribute } from 'app/model/base/annotation';
import { Metamodel } from 'app/model/base/model';
import { AzureTableDataset } from 'app/model/dataset/azure-table.dataset';

import { sanitizeAndFormatString } from 'app/shared/utils/string.util';

export const azureTablePartitionKeyRegex = new RegExp(/^[^/\\#?\u0000-\u001F\u007F-\u009F]*$/);

@Metamodel.model({
    name: 'AzureTableSink',
    display: [],
    referable: true,
    tags: { datasetModel: Metamodel.modelFor(AzureTableDataset) }
})
export class AzureTableSink extends TabularCopySink {
    public static readonly MODEL: IModel;
    public static readonly INSER_TYPE: IAttribute;
    public static readonly ROW_KEY_NAME: IAttribute;
    public static readonly PARTITION_KEY_NAME: IAttribute;
    public static readonly DEFAULT_PARTITION_KEY_VALUE: IAttribute;

    @Metamodel.attribute({
        templatable: true,
        association: 'WRITE_BATCH_SIZE',
        display: stringResources.ModelName_WriteBatchSize
    })
    public writeBatchSize?: number = 10000;

    @Metamodel.attribute({
        templatable: true,
        association: 'INSER_TYPE',
        display: stringResources.InsertTypeLabel
    })
    public insertType: 'merge' | 'replace' = 'merge';

    @Metamodel.attribute({
        templatable: true,
        association: 'ROW_KEY_NAME',
        display: stringResources.ModelName_RowKeyName
    })
    public rowKeyName?: string;

    @Metamodel.attribute({
        templatable: true,
        association: 'PARTITION_KEY_NAME',
        display: stringResources.ModelName_PartitionKeyName
    })
    public partitionKeyName?: string;

    @Metamodel.attribute({
        templatable: true,
        association: 'DEFAULT_PARTITION_KEY_VALUE',
        display: stringResources.Default_Partition_Value_Label,
        constraint: {
            validator: AzureTableSink.validateDefaultPartitionKeyValue
        }
    })
    public defaultPartitionKeyValue?: string;

    public useColumnNameForRowKey: boolean = false;
    public useColumnNameForPartitionKey: boolean = false;

    private static validateDefaultPartitionKeyValue(copySink: AzureTableSink): IViolation[] | undefined {
        const regExp = azureTablePartitionKeyRegex;
        if (!copySink.useColumnNameForPartitionKey && copySink.defaultPartitionKeyValue && !regExp.test(copySink.defaultPartitionKeyValue)) {
            return [
                {
                    message: () => sanitizeAndFormatString(stringResources.PatternValidatorMessage, stringResources.Default_Partition_Value_Label,
                        '', copySink.defaultPartitionKeyValue, regExp.toString())
                }
            ];
        }
        return undefined;
    }
}
